var _excluded = ["children", "rtl", "className", "anchorUrlParameter"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './TestimonialCarousel.css';
import React, { useRef } from 'react';
import ComponentsWrapper from "../atoms/ComponentsWrapper";
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { get } from '../../utils';
import { TestimonialCarouselCard } from '../51_TestimonialCarouselCard/TestimonialCarouselCard';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
var TestimonialCarousel = function TestimonialCarousel(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var ctaLink = get(fields, "data.item.ctaLink.jss.value.href", "");
  var ctaLabel = get(fields, "data.item.ctaLabel.jss.value", "");
  var currentIndex = useRef(0);
  var items = get(fields, 'data.item.children', []);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderItems = function renderItems() {
    return items.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.name,
        className: "testimonial__list"
      }, /*#__PURE__*/React.createElement(TestimonialCarouselCard, {
        inCarousel: items.length > 1,
        params: params,
        image: item.authorPicture,
        authorName: item.authorName,
        authorDescription: item.authorDescription,
        quoteText: item.quoteText,
        title: item.title,
        hasQuoteMark: item.hasQuoteMark,
        video: item.video,
        onVideoBtnClick: function onVideoBtnClick(val) {
          return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["playPausedVideo"], params), [val, item.title.jss.value]);
        }
      }));
    });
  };
  var seeMoreTracking = function seeMoreTracking(ctaLabel) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["seeMore"], params), ctaLabel);
  };
  if (!fields) {
    console.info('TestimonialMultipleMedia component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TestimonialMultipleMedia component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial"
  }, items.length > 1 ? /*#__PURE__*/React.createElement(CarouselProvider, {
    getCurrentActiveItem: function getCurrentActiveItem(nextSlide) {
      return currentIndex.current = nextSlide;
    }
  }, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots;
    return /*#__PURE__*/React.createElement("div", {
      className: "row testimonial-multiple"
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right btn-group-arrows ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], params), "previous");
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], params), "next");
    })), /*#__PURE__*/React.createElement("div", {
      className: "testimonial__bottom-wrapper"
    }, ctaLabel && /*#__PURE__*/React.createElement("a", {
      href: ctaLink,
      target: "_blank",
      "aria-label": ctaLabel,
      rel: "noopener noreferrer",
      className: "btn btn-secondary form-label__radio testimonial__btn",
      onClick: function onClick() {
        return seeMoreTracking(ctaLabel);
      }
    }, ctaLabel), renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNavigatorBubbles"], params));
    })));
  }) : renderItems()));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    className = _ref.className,
    anchorUrlParameter = _ref.anchorUrlParameter,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsWrapper, _extends({
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, otherProps), children);
};
export var commonStyles = "co3z9lh";
export default TestimonialCarousel;
export var ltrStyles = "l1rk2vwk";
export var rtlStyles = "r570127";